"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSalesforceRefCountsByEntity = void 0;
const sonar_http_1 = require("@sonar-software/sonar-http");
exports.getSalesforceRefCountsByEntity = (0, sonar_http_1.createGetEndpoint)((request) => {
    const params = new URLSearchParams(request.names.map((n) => ['names', n]));
    return `/api/v3/salesforce/ref-counts/by-entity?${params}`;
});
//# sourceMappingURL=getSalesforceRefCountsByEntity.js.map